var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form tab-content", staticStyle: { "min-height": "200px" } },
    [
      _c(
        "v-layout",
        { staticStyle: { width: "100%" } },
        [
          _vm.canAddNetworkElements
            ? _c("asset-selection", {
                attrs: {
                  template: _vm.template,
                  filters: [],
                  "layers-to-show": _vm.layersToShow
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.canAddNetworkElements
            ? _c("v-divider", { attrs: { vertical: "" } })
            : _vm._e(),
          _vm._v(" "),
          _c("selected-assets", {
            attrs: {
              tab: "networkElements",
              "action-type": _vm.actionType,
              "asset-reservation-objects": _vm.networkElements,
              "user-can-add-objects": _vm.canAddNetworkElements
            },
            on: {
              "update-asset-reservation-objects": function($event) {
                return _vm.$emit("update-network-elements", $event)
              },
              "dissociate-asset-reservation-object": function($event) {
                return _vm.$emit("dissociate-asset-reservation-object", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14f342f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14f342f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/AssetReservationForm/NetworkElementsTab.vue
// module id = null
// module chunks = 